// extracted by mini-css-extract-plugin
export default {"view":"views__view__1scmt","content":"views__content__19YYg","headline":"views__headline__2OBfF"};